import { usePlanPrice as usePrice } from "@/components/features/items/edit/plan/_shared/ui/components/price/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const usePlanPrice = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { billingTypeTarget, billingTypeTerm, price } = viewModel;

	return usePrice({
		billingTypeTarget,
		billingTypeTerm,
		price,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		onSetViewModel: onSetViewModel as unknown as any,
	});
};
